var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from "vue-property-decorator";
import { plansDetailService } from "../../services/plans-detail.service";
import Tooltip from "../tooltip.vue";
var PlanCard = /** @class */ (function (_super) {
    __extends(PlanCard, _super);
    function PlanCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "plan-card";
        _this.specials = [];
        _this.plansDetailService = plansDetailService;
        _this.phoneNumberText = '0800 005 751';
        _this.plan_desc_expanded = false;
        return _this;
    }
    PlanCard.prototype.created = function () {
        if (window.hasOwnProperty('phone_number_option')) {
            this.phoneNumberText = window.phone_number_option;
        }
    };
    PlanCard.prototype.stylizePlanSizes = function (numberInMegaBytes) {
        if (isNaN(parseInt(numberInMegaBytes))) {
            return "Unlimited";
        }
        return "".concat(parseInt(numberInMegaBytes) / 1000, "GB");
    };
    PlanCard.prototype.isEqualSize = function (numberInMegs) {
        var gigs = parseInt(numberInMegs) / 1000;
        this.specials.includes(gigs.toString());
    };
    Object.defineProperty(PlanCard.prototype, "fullQuota", {
        get: function () {
            return parseInt(this.plan.details.normal_quota) + parseInt(this.plan.details.bonus_quota);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanCard.prototype, "kisLink", {
        get: function () {
            return plansDetailService.getKFSLink(this.plan.details.technology, this.plan.details.speed_tier, this.plan.plan);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanCard.prototype, "isSMPlus", {
        get: function () {
            return this.plan.details.speed_tier === 'SMP' || this.plan.details.speed_tier === 'SMP2020';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanCard.prototype, "isWirelessPlus", {
        get: function () {
            var _a;
            var wirelessPlusPlans = [
                'Wireless Plus - Limitless',
                'Wireless Plus - 600'
            ];
            return wirelessPlusPlans.indexOf((_a = this.plan) === null || _a === void 0 ? void 0 : _a.plan) >= 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanCard.prototype, "cisLink", {
        get: function () {
            return plansDetailService.getCISLink(this.plan.details.technology, this.plan.details.speed_tier, this.plan.plan);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ default: {}, type: Object })
    ], PlanCard.prototype, "plan", void 0);
    __decorate([
        Prop({ default: -1, type: Number })
    ], PlanCard.prototype, "addressId", void 0);
    __decorate([
        Prop({ default: "", type: String })
    ], PlanCard.prototype, "confirmedTechnology", void 0);
    __decorate([
        Prop({ default: "", type: String })
    ], PlanCard.prototype, "pageTechnology", void 0);
    __decorate([
        Prop({ default: false, type: Boolean })
    ], PlanCard.prototype, "showExtra", void 0);
    __decorate([
        Prop({ default: false, type: Boolean })
    ], PlanCard.prototype, "callOnly", void 0);
    PlanCard = __decorate([
        Component({
            components: { Tooltip: Tooltip }
        })
    ], PlanCard);
    return PlanCard;
}(Vue));
export default PlanCard;
